import React, { useState, useEffect } from 'react';
import axios from 'axios';

function AlertsList() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    axios.get('/api/admin/alerts').then(res => setAlerts(res.data));
  }, []);

  const markRead = async (alertId) => {
    await axios.post(`/api/admin/alerts/${alertId}/read`);
    setAlerts(prev => prev.map(a => a.id === alertId ? { ...a, is_read: true } : a));
  };

  const getAlertColor = (type) => {
    if (type.includes('critical')) return 'red';
    if (type.includes('warning')) return 'yellow';
    return 'green';
  };

  const getAlertLabel = (type) => {
    switch (type) {
      case 'long_open_warning': return 'שער פתוח ארוך';
      case 'long_open_critical': return 'שער פתוח קריטי';
      case 'cycle_warning': return 'מתקרב לטיפול';
      case 'cycle_critical': return 'הגיע ליעד טיפול';
      default: return type;
    }
  };

  return (
    <>
      <h2 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '1.25rem' }}>התראות</h2>
      <div className="data-table">
        <table>
          <thead>
            <tr>
              <th>סוג</th>
              <th>הודעה</th>
              <th>שער</th>
              <th>אתר</th>
              <th>לקוח</th>
              <th>זמן</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {alerts.map(a => (
              <tr key={a.id} className={a.is_read ? 'alert-row-read' : 'alert-row-unread'} style={{ cursor: 'default' }}>
                <td>
                  <span className={`status-dot ${getAlertColor(a.alert_type)}`} style={{ marginLeft: '0.4rem' }}></span>
                  {getAlertLabel(a.alert_type)}
                </td>
                <td>{a.message}</td>
                <td>{a.gate_name}</td>
                <td>{a.site_name}</td>
                <td>{a.customer_name}</td>
                <td>{new Date(a.timestamp).toLocaleString('he-IL', { timeZone: 'Asia/Jerusalem' })}</td>
                <td>
                  {!a.is_read && (
                    <button className="btn btn-secondary btn-sm" onClick={() => markRead(a.id)}>סמן כנקרא</button>
                  )}
                </td>
              </tr>
            ))}
            {alerts.length === 0 && (
              <tr><td colSpan="7" style={{ textAlign: 'center', color: '#9ca3af', padding: '2rem' }}>אין התראות</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default AlertsList;
